import {
    $createRangeSelection,
    $createTextNode,
    $getSelection,
    $isRangeSelection,
    LexicalEditor
} from "lexical"

const debug = false
// const debug = "lexicalInsertMentionTrigger"

export function lexicalInsertMentionTrigger(editor: LexicalEditor) {
    editor.update(() => {
        let selection = $getSelection()
        if (!$isRangeSelection(selection)) selection = $createRangeSelection()

        debug && console.log(debug, 'update', $isRangeSelection(selection), selection)

        const textNode = $createTextNode('@')
        selection.insertNodes([textNode])
    })
}